import {
  OrderEligibilityInformation,
} from '@dapi/sdk';
import {
  amopRefundOptions,
  arnEwrRefundOptions,
  cancelAndRefundForMiles,
  cancelAndRefundForMilesWithoutCancellation,
  cancelAndRefundForMilesWithTwoPax,
  cancelAndRefundForMilesWithTwoPaxWithoutPenalty,
  cancelAndRefundWithObFee,
  cardRefundTypeInvoluntaryOptions,
  involuntaryRefundableWithMultipleVoucher,
  involuntaryRefundOption,
  nonEligibilityReasonCode2,
  nonEligibilityReasonCode6,
  nonEligibilityRefundReasonCode24,
  refundableWithMultipleVoucher,
  refundOptions,
  voucherRefundOptions,
  voucherRefundTypeInvoluntaryOptions,
  voucherWithCCInvoluntaryRefundOptions,
  voucherWithCCRefundOptions,
} from '../dictionaries';
import {
  orderForMultiPaxOneWay,
  orderForSingleBoundDisrupted,
  orderForUnOneWayOnly,
  orderForUnOnlyRoundTrip,
  orderMockEligibleToRefund,
  orderMockEligibleToRefundUsingAmop,
  orderMockEligibleToRefundUsingMultipleVouchersAndCC,
  orderWithBothBoundsDisrupted,
  orderWithInvolutaryRefundEligibleOneWayDisruptedUsingAmop,
} from './refactored-mock-order';

export const orderEligibilitiesMockEligibleToRefundWithUnOneWay: OrderEligibilityInformation = {
  orderId: orderForUnOneWayOnly.id,
  cancelAndRefund: {
    refundStatus: 'notRefundable',
    nonEligibilityReasons: [nonEligibilityReasonCode6]
  }
};

export const orderEligibilitiesMockEligibleToRefundWithUnRoundTrip = {
  ...orderEligibilitiesMockEligibleToRefundWithUnOneWay,
  orderId: orderForUnOnlyRoundTrip.id
};

export const orderEligibilitiesMockEligibleFororderForMultiPaxOneWay: OrderEligibilityInformation = {
  orderId: orderForMultiPaxOneWay.id,
  cancelAndRefund: refundOptions
};

export const orderEligibilitiesMockEligibleToRefund: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefund.id,
  cancelAndRefund: arnEwrRefundOptions
};

export const orderEligibilitiesMockEligibleToRefundUsingAmop: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  cancelAndRefund: amopRefundOptions
};

export const orderEligibilitiesMockEligibleToRefundUsingMultipleVoucherButOnlyOneIsEligible: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  cancelAndRefund: refundableWithMultipleVoucher
};

export const orderEligibilitiesMockEligibleToInvoluntaryRefundUsingMultipleVoucherButOnlyOneIsEligible: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  cancelAndRefund: involuntaryRefundableWithMultipleVoucher
};

export const orderEligibilitiesMockEligibleToRefundUsingMultipleVoucherWithCCEligible: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingMultipleVouchersAndCC.id,
  cancelAndRefund: voucherWithCCRefundOptions
};

export const orderEligibilitiesMockEligibleToInvoluntaryRefundUsingMultipleVoucherWithCCEligible: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingMultipleVouchersAndCC.id,
  cancelAndRefund: voucherWithCCInvoluntaryRefundOptions
};

export const orderEligibilitiesMockEligibleToRefundUsingVoucher: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  cancelAndRefund: voucherRefundOptions
};

export const orderEligibilitiesMockEligibleToRefundTypeInvoluntaryUsingVoucher: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  cancelAndRefund: voucherRefundTypeInvoluntaryOptions
};

export const orderEligibilitiesMockEligibleToRefundTypeInvoluntaryUsingCard: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  cancelAndRefund: cardRefundTypeInvoluntaryOptions
};

export const orderEligibilitiesMockNotEligibleToRefund: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefund.id,
  cancelAndRefund: {
    refundStatus: 'notRefundable',
    nonEligibilityReasons: [nonEligibilityReasonCode2]
  }
};

export const orderEligibilitiesMockNotEligibleToRefundForSingleBound: OrderEligibilityInformation = {
  orderId: orderForSingleBoundDisrupted.id,
  cancelAndRefund: {
    refundStatus: 'notRefundable',
    nonEligibilityReasons: [nonEligibilityRefundReasonCode24]
  }
};

export const orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip: OrderEligibilityInformation = {
  orderId: orderWithBothBoundsDisrupted.id,
  cancelAndRefund: {
    refundStatus: 'notRefundable',
    nonEligibilityReasons: [nonEligibilityReasonCode6]
  }
};

export const orderEligibilitiesMockEligibleFororderForMultiPaxRoundTrip: OrderEligibilityInformation = {
  orderId: orderWithBothBoundsDisrupted.id,
  cancelAndRefund: refundOptions
};

export const orderEligibilitiesMockEligibleForInvolutaryRefundOneWayDisruptedUsingAmop: OrderEligibilityInformation = {
  orderId: orderWithInvolutaryRefundEligibleOneWayDisruptedUsingAmop.id,
  cancelAndRefund: involuntaryRefundOption
};

export const mockOrderEligibilitiesWithMiles: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefund.id,
  cancelAndRefund: cancelAndRefundForMiles
};

export const mockOrderEligibilitiesWithMilesForTwoPax: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefund.id,
  cancelAndRefund: cancelAndRefundForMilesWithTwoPax
};

export const mockOrderEligibilitiesWithMilesForTwoPaxWithoutPenalty: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefund.id,
  cancelAndRefund: cancelAndRefundForMilesWithTwoPaxWithoutPenalty
};

export const mockOrderEligibilitiesWithMilesWithoutCancellation: OrderEligibilityInformation = {
  orderId: orderMockEligibleToRefund.id,
  cancelAndRefund: cancelAndRefundForMilesWithoutCancellation
};

export const getOrderEligibilitiesMockDisruptedOutboundRefundable: OrderEligibilityInformation = {
  orderId: orderForSingleBoundDisrupted.id,
  cancelAndRefund: cancelAndRefundWithObFee
};
